import React from 'react'
import PostImage from '../../src/utils/PostImage.js'
import post_4_1 from '../../src/images/blog/post_4_dependencies.svg'
import post_4_2 from '../../src/images/blog/post_4_finishToStart.svg'
import post_4_3 from '../../src/images/blog/post_4_finishToFinish.svg'
import post_4_4 from '../../src/images/blog/post_4_startToStart.svg'
import post_4_5 from '../../src/images/blog/post_4_startToFinish.svg'
import post_5_1 from '../../src/images/blog/post_5_1_pros-and-cons.svg'

const posts = [
  {
    title: 'MoSCoW Method',
    date: '12/13/2020',
    author: 'Yury Shkoda',
    images: [
      <PostImage image="post_5_0" alt="MoSCoW Method" />,
      <img src={post_5_1} alt="MoSCoW Method Pros and Cons" />
    ],
    link: 'moscow-method'
  },
  {
    title: 'Project Dependencies and Relationships',
    date: '12/5/2020',
    author: 'Yury Shkoda',
    images: [
      <PostImage
        image="post_4_0"
        alt="Project Dependencies and Relationships"
      />,
      <img src={post_4_1} alt="Types of project dependencies" />,
      <img src={post_4_2} alt="Finish to Start" />,
      <img src={post_4_3} alt="Finish to Finish" />,
      <img src={post_4_4} alt="Start to Start" />,
      <img src={post_4_5} alt="Start to Finish" />
    ],
    link: 'project-dependencies-and-relationships'
  },
  {
    title: 'Kanban explained',
    date: '5/2/2020',
    author: 'Yury Shkoda',
    images: [
      <PostImage image="post_3_0" alt="Kanban explained" />,
      <PostImage image="post_3_1" alt="Kanban classic board" />,
      <PostImage image="post_3_2" alt="Kanban software development board" />,
      <PostImage image="post_3_3" alt="Kanban principles" />,
      <PostImage image="post_3_4" alt="Kanban practices" />,
      <PostImage image="post_3_5" alt="Explicit guidelines on Kanban board" />
    ],
    link: 'kanban-explained'
  },
  {
    title: 'Scrum of Scrums (SoS)',
    date: '4/17/2020',
    author: 'Yury Shkoda',
    images: [
      <PostImage image="post_2" alt="Scrum of Scrums (SoS)" />,
      <PostImage image="post_2_1" alt="Scrum of Scrums (SoS)" />
    ],
    link: 'scrum-of-scrums-sos'
  },
  {
    title: 'PMP formulas you have to know',
    date: '4/8/2020',
    author: 'Yury Shkoda',
    images: [<PostImage image="post_1" alt="PMP formulas cheat sheet" />],
    link: 'pmp-formulas-cheat-sheet',
    formulas: [
      {
        formula: `PV = Planned % Complete * BAC`,
        definition: 'What the project should be worth',
        abbreviations: ['PV - planned value', 'BAC - budget at completion']
      },
      {
        formula: `EV = Actual % Complete * BAC`,
        definition: 'What the project is worth',
        abbreviations: ['EV - earned value', 'BAC - budget at completion']
      },
      {
        formula: `SD = (P - O) / 6`,
        definition: 'SD measures the Variation from Average',
        abbreviations: [
          'SD - standard deviation',
          'P - pessimistic estimate',
          'O - optimistic estimate'
        ]
      },
      {
        formula: `EAD = (O + 4R + P) / 6`,
        definition: 'EAD calculated by beta distribution',
        abbreviations: [
          'EAD - estimated activity duration',
          'R - realistic estimate',
          'P - pessimistic estimate',
          'O - optimistic estimate'
        ]
      },
      {
        formula: `EAD = (O + R + P) / 3`,
        definition: 'EAD calculated by triangular distribution',
        abbreviations: [
          'EAD - estimated activity duration',
          'R - realistic estimate',
          'P - pessimistic estimate',
          'O - optimistic estimate'
        ]
      },
      {
        formula: `CV = EV - AC`,
        definition:
          'CV represents the amount of budget deficit or surplus at a given point in time',
        abbreviations: [
          'CV - cost variance',
          'EV - earned value',
          'AC - actual cost'
        ],
        notes: ['<0 over budget', '=0 on budget', '>0 under budget']
      },
      {
        formula: `SV = EV - PV`,
        definition:
          'SV aims to measure schedule performance through the difference between the earned value and the planned value',
        abbreviations: [
          'SV - schedule variance',
          'EV - earned value',
          'PV - planned value'
        ],
        notes: ['<0 behind schedule', '=0 on schedule', '>0 ahead of schedule']
      },
      {
        formula: `CPI = EV / AC`,
        definition: 'CPI measures the cost efficiency of budgeted resources',
        abbreviations: [
          'CPI - cost performance index',
          'EV - earned value',
          'AC - actual cost'
        ],
        notes: ['<1 over budget', '=1 on budge', '>1 under budget']
      },
      {
        formula: `SPI = EV / PV`,
        definition: 'SPI  measures schedule efficiency',
        abbreviations: [
          'SPI - schedule performance index',
          'EV - earned value',
          'PV - planned value'
        ],
        notes: ['<1 behind schedule', '=1 on schedule', '>1 ahead of schedule']
      },
      {
        formula: `ETC = EAC - AC`,
        definition:
          'ETC predicts how much more the remainder of the project will cost',
        abbreviations: [
          'ETC - estimate to complete',
          'EAC - estimate at completion',
          'AC - actual cost'
        ]
      },
      {
        formula: `EAC = BAC / CPI`,
        definition: 'Predicts final project costs based on current performance',
        abbreviations: [
          'EAC - estimate at completion',
          'BAC - budget at completion',
          'CPI - cost performance index'
        ]
      },
      {
        formula: `EAC = AC + BAC - EV`,
        definition: 'Predicts final project costs based on current performance',
        abbreviations: [
          'EAC - estimate at completion',
          'BAC - budget at completion',
          'AC - actual cost',
          'EV - earned value'
        ]
      },
      {
        formula: `EAC = AC + [(BAC - EV) / (CPI * SPI)]`,
        definition: 'Predicts final project costs based on current performance',
        abbreviations: [
          'EAC - estimate at completion',
          'BAC - budget at completion',
          'AC - actual cost',
          'EV - earned value',
          'CPI - cost performance index',
          'SPI - schedule performance index'
        ]
      },
      {
        formula: `VAC = BAC - EAC`,
        definition:
          'VAC is a projection of the amount of budget deficit or surplus',
        abbreviations: [
          'VAC - variance at completion',
          'BAC - budget at completion',
          'EAC - estimate at completion'
        ],
        notes: ['<0 under budget', '=0 on budget', '>0 over budget']
      },
      {
        formula: `TCPI = (BAC - EV) / (BAC - AC)`,
        definition: 'Predicts likelihood of reaching BAC',
        abbreviations: [
          'TCPI - to-complete performance index',
          'BAC - budget at completion',
          'EV - earned value',
          'AC - actual cost'
        ],
        notes: [
          '<1 easier to complete and meet BAC',
          '>1 harder to complete and meet BAC'
        ]
      },
      {
        formula: `TCPI = (BAC - EV) / (EAC - AC)`,
        definition: 'Predicts likelihood of reaching EAC',
        abbreviations: [
          'TCPI - to-complete performance index',
          'BAC - budget at completion',
          'EV - earned value',
          'AC - actual cost',
          'EAC - estimate at completion'
        ],
        notes: [
          '<1 easier to complete and meet EAC',
          '>1 harder to complete and meet EAC'
        ]
      },
      {
        formula: `N * (N - 1) / 2`,
        definition: 'Number of communication channels',
        abbreviations: ['N - number of team members'],
        notes: [
          'If the number of team members increases, the number of communication channels also increases'
        ]
      },
      {
        formula: `Slack = LS - ES`,
        definition:
          'Date constraints, within which we can plan our activity without affecting the overall length of the project',
        abbreviations: ['LS - late start', 'ES - early start']
      },
      {
        formula: `Slack = LF - EF`,
        definition:
          'Date constraints, within which we can plan our activity without affecting the overall length of the project',
        abbreviations: ['LF - late finish', 'EF - early finish']
      },
      {
        formula: `EF = ES + Duration - 1`,
        definition:
          'The earliest you can finish the activity without delaying the project end date',
        abbreviations: ['EF - early finish', 'ES - early start']
      },
      {
        formula: `LS = LF - Duration + 1`,
        definition:
          'The latest you can start the activity without delaying the project end date',
        abbreviations: ['LS - late start', 'LF - late finish']
      },
      {
        formula: `EMV = Probability * Impact`,
        definition:
          'EMV represents the expected money to be made from a specific decision',
        abbreviations: ['EMV - expected monetary value']
      },
      {
        formula: `ROI = (Net Profit / COI) * 100`,
        definition:
          'Measures profit or loss gained through an investment based on the amount invested',
        abbreviations: [
          'ROI - return on investment',
          'COI - cost of investment'
        ]
      },
      {
        formula: `CBR = NPV / initial investment cost`,
        definition:
          'CBR tells about the profit to be received from an investment',
        abbreviations: ['CBR - cost-benefit ratio', 'NPV - net present value']
      },
      {
        formula: `NPV = Value / (1 + r) ^ t`,
        definition: 'Net present value of investment',
        abbreviations: [
          'Value - value of benefits',
          'r - rate of discount',
          't - defined time frame'
        ]
      }
    ],
    cheatSheet: [
      'CV = EV - AC',
      'SV = EV - PV',
      'EAC = BAC / CPI',
      'VAC = BAC - EAC',
      'CPI = EV / AC',
      'SPI = EV / PV',
      'ETC = EAC - AC',
      'TCPI = (BAC - EV) / (BAC - AC)',
      'PV = Planned % Complete * BAC',
      'EV = Actual % Complete * BAC'
    ]
  }
]

export default posts
